<template>
  <div class="row m-0 h-100">
    <div class="col-12 fixed_top">
      <div class="row m-0 justify-content-end">
        <div class="col-2 mt-5">
          <img src="../assets/images/logo.png" class="img-fluid">
        </div>
      </div>
    </div>
    <div class="col-5 p-0 bg h-100">
      <div class="row m-0 mt-5 pt-5">
        <div class="col-12 p-0 text-right pr-1">
          <h1>DISCOVERY</h1>
        </div>
      </div>
    </div>
    <div class="col-7 h-100">
      <div class="row m-0 mt-5 pt-5">
        <div class="col-12 p-0 mb-5">
          <h1><span class="gradient">WORLD GAME</span></h1>
        </div>
        <div class="col-12 mt-2 mb-2">
          <h3><span class="gradient">PERSONAL DETAILS</span></h3>
        </div>
        <div class="col-2 mt-2 pt-1">
          <div class="border_gradient"></div>
        </div>
        <div class="col-12 mt-3 ">
          <div class="form-group">
            <input v-model="name" type="text" class="form-control" id="name" placeholder="Name">
          </div>
          <div class="form-group">
            <input v-model="surname" type="text" class="form-control" id="surname" placeholder="Surname">
          </div>
          <div class="form-group">
            <input v-model="cell" type="text" class="form-control" id="cell" placeholder="Cellphone number">
          </div>
          <div class="form-group">
            <input v-model="code" type="text" class="form-control" id="cardnumber" placeholder="Unique scratch card number">
          </div>
          <div class="form-group" style="color: red;">
            <label v-if="message.length > 0">{{ message }}</label>
          </div>
          <div class="form-group">
            <!-- <label v-show="false">hello</label> -->
            <label class="labl w-100 font_55reg font14 mb-0" for="terms">
              <input v-model="acceptTCs" type="checkbox" id="terms" value="terms">
              <div>
                <span class="pl-3">I accept the <a href="http://navigatehost.co.za/discovery/FIA_Summit_App/Discovery_World_game_TsCs.pdf" target="_blank">terms and conditions</a></span>
              </div>
            </label>
          </div>
        </div>
      </div>
      <div class="row justify-content-end abs">
        <div class="col-4">
          <div class="row m-0">
            <div class="col-12 text-right">
              <button :disabled="!canProceed" @click="submit()" class="btn btn-gradient pl-5 pr-5">Submit</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { firestore } from '@/firebase.config'
import { mapActions } from 'vuex'
export default {
  name: 'Landing',
  computed: {
    canProceed () {
      if (this.name.length > 0 && this.surname.length > 0 && this.cell.length === 10 && this.code.length > 0 && this.acceptTCs) {
        return true
      }
      return false
    }
  },
  data () {
    return {
      name: '',
      surname: '',
      cell: '',
      code: '',
      acceptTCs: false,
      message: ''
    }
  },
  methods: {
    ...mapActions([
      'setCode'
    ]),
    submit () {
      let vm = this
      vm.message = ''
      firestore.collection('participants').doc(vm.code).get().then(doc => {
        if (doc.exists) {
          if (doc.data().entered) {
            // alert('Code Already Enterd')
            vm.message = 'This unique scratch card number has already been used.'
          } else {
            this.setCode(vm.code)
            firestore.collection('participants').doc(vm.code).update({
              name: vm.name,
              surname: vm.surname,
              cell: vm.cell,
              acceptTCs: true,
              entered: true,
              createdDateTime: new Date()
            }).then(ref => {
              this.$router.push('/select')
            })
          }
        } else {
          vm.message = 'Invalid unique scratch card number - please try again.'
          // alert('Invalid Code')
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.fixed_top {
  position: fixed;
  top: 0;
}
.bg {
/*   background-image: url('../assets/images/side_bg.png'); */
  background: -webkit-linear-gradient(45deg, rgb(0, 75, 141) 0%, rgb(185, 140, 96) 100%);
  background-size: cover;
}
.border_gradient {
  background: -webkit-linear-gradient(0deg, rgb(0, 75, 141) 0%, rgb(185, 140, 96) 75%);
  padding: 1px 0;
}
.form-group {
  margin-bottom: 1.5rem;
}
.form-control {
  border: none;
  box-shadow: 6px 6px 8px 0 rgba(0, 0, 0, 0.3);
}
.abs {
  position: absolute;
  bottom: 3vh;
  width: 100%;
}
.btn-gradient {
  background: -webkit-linear-gradient(0deg, rgb(0, 75, 141) 0%, rgb(185, 140, 96) 95%);
  border-radius: 0;
  border: none;
  color: #fff;
}
.labl {
  cursor: pointer;
  padding-left: 1rem;
}
.labl > input{ /* HIDE RADIO */
    visibility: hidden; /* Makes input not-clickable */
}
.labl > input + div{ /* DIV STYLES */
  width: 100%;
}
.labl > input + div:before {
  border-radius: 2px;
  border: none;
  box-shadow: 2px 3px 8px 2px rgba(0, 0, 0, 0.3);
  background: #fff;
  display: inline-block;
  width: 16px;
  height: 16px;
  content:"";
}
.labl > input:checked + div:before {
  width: 16px;
  height: 16px;
  content:"";
  background: rgb(185, 140, 96);
  border: 2px solid #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/Landing.vue